import { Switch } from "@/components/ui/switch";
import {
  useHandoffOnlyPhoneNotifications,
  useUpdateHandoffOnlyPhoneNotifications,
} from "@/hooks/useHandoffOnlyPhoneNotifications";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

/**
 * «Avisar solo a partir del handoff». Shown for a QR (Baileys) connection only:
 * the switch's first half is keeping the linked device "en línea", which is what
 * silences the phone, and the Cloud API has no device. Saves the moment it is
 * flipped, like the «Notificaciones» switches.
 */
export function WhatsAppHandoffOnlyNotifications(): React.JSX.Element {
  const { data, isPending, isError } = useHandoffOnlyPhoneNotifications();
  const update = useUpdateHandoffOnlyPhoneNotifications();

  return (
    <div className="w-full max-w-sm rounded-xl border border-ink-100 bg-white p-8 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <label
            htmlFor="handoff-only-notifications"
            className="text-base font-semibold text-ink-900"
          >
            Avisar solo a partir del handoff
          </label>
          <p className="mt-1 text-sm text-ink-500">
            Apagado: el teléfono de esta cuenta de WhatsApp suena con cada mensaje de cada
            prospecto. Encendido: el teléfono no suena mientras el agente atiende el chat; cuando
            el chat pasa a una persona, cada mensaje nuevo del prospecto llega como alerta a los
            teléfonos de notificación (y a la campana del CRM si tienes Notificaciones web).
          </p>
        </div>
        <Switch
          id="handoff-only-notifications"
          checked={data?.enabled ?? false}
          disabled={isPending || isError || update.isPending}
          onCheckedChange={(enabled) => update.mutate({ enabled })}
          aria-label="Avisar solo a partir del handoff"
        />
      </div>
      {isError && (
        <p className="mt-3 text-xs text-red-500">No se pudo cargar la configuración.</p>
      )}
      {data?.updatedAt && (
        <p className="mt-3 text-xs text-ink-500">
          Último cambio{data.updatedByName ? ` por ${data.updatedByName}` : ""} el{" "}
          {formatDate(data.updatedAt)}.
        </p>
      )}
    </div>
  );
}
